<template>
    <div>baseInfo 这个组件很难配</div>
</template>

<script>
export default {
    name: 'baseInfo',

};
</script>


// WEBPACK FOOTER //
// src/staticComponents/baseInfo/baseInfo.vue